import { UseFormReturn } from 'react-hook-form';

import { BasicInfoForm } from '../schema';
import { FormStep, FormStepHeader } from './form/form-step';
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/new/components/shadcn/form';
import { Input } from '@/new/components/shadcn/input';

interface BasicInfoStepProps {
  form: UseFormReturn<BasicInfoForm>;
}

export function BasicInfoStep({ form }: BasicInfoStepProps) {
  return (
    <FormStep>
      <FormStepHeader
        title="Basic Information"
        description="Enter basic information about your matter."
        icon="lucide--info"
      />

      <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
        <div className="md:col-span-2">
          <FormField
            control={form.control}
            name="name"
            render={({ field }) => (
              <FormItem>
                <FormLabel>
                  Matter Name<span className="ml-1 text-teal-500">*</span>
                </FormLabel>
                <FormControl>
                  <Input
                    {...field}
                    placeholder="E.g. Company A vs Company B..."
                    data-testid="matter-creator-name-field"
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </div>

        <div>
          <FormField
            control={form.control}
            name="code"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Matter Code (Optional)</FormLabel>
                <FormControl>
                  <Input {...field} placeholder="Matter code..." data-testid="matter-creator-code-field" />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </div>

        <div>
          <FormField
            control={form.control}
            name="tokenLimit"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Credit Limit (Optional)</FormLabel>
                <FormControl>
                  <Input
                    {...field}
                    type="number"
                    placeholder="E.g. 50000..."
                    data-testid="matter-creator-token-limit-field"
                    min="0"
                    step="1000"
                    onChange={(e) => field.onChange(e.target.value ? parseInt(e.target.value) : undefined)}
                    value={field.value ?? ''}
                  />
                </FormControl>
                <p className="mt-1.5 text-xs text-gray-500">Maximum credits in this matter.</p>
                <FormMessage />
              </FormItem>
            )}
          />
        </div>
      </div>
    </FormStep>
  );
}
